import GET_EIGHT_LEGGED_FREAK_LIST from "./getEightLeggedFreakList"
import GET_EIGHT_LEGGED_FREAK_NEWS_SOURCES_LIST from "./getEightLeggedFreakNewsSourcesList"

export default {
  GET_EIGHT_LEGGED_FREAK_LIST,
  GET_EIGHT_LEGGED_FREAK_NEWS_SOURCES_LIST
}
